import { useIntl, useSettings } from '@capsicum/common';
import { useTrackUKRegulationEvents } from '@capsicum/socios-core';
import { type ReactNode } from 'react';
import styled from 'styled-components';

type UkRiskWarningConfirmationBodyProps = {
	fullName: string;
};

export const UkRiskWarningConfirmationBody = ({ fullName }: UkRiskWarningConfirmationBodyProps) => {
	const { $t } = useIntl();
	const { settings } = useSettings();
	const { trackUKRiskWarningLinkClick } = useTrackUKRegulationEvents();

	return (
		<>
			<S.Container>
				<S.Text>
					{$t('jurisdictionRequirements.ukRiskWarning.warningText', {
						fullName,
						link: (chunks: Array<ReactNode>) => (
							<S.Link
								data-testid="uk-risk-link"
								href={settings?.ukRiskLink}
								target="_blank"
								onClick={trackUKRiskWarningLinkClick}
							>
								{chunks}
							</S.Link>
						)
					})}
				</S.Text>
			</S.Container>
			<S.Text>{$t('jurisdictionRequirements.ukRiskWarning.agreeByProceeding')}</S.Text>
		</>
	);
};

namespace S {
	export const Container = styled.div`
		background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
		border: ${({ theme }) => `1px solid ${theme.colors.borders.main.unselected}`};
		border-radius: ${({ theme }) => theme.sizing.xxxsmall};
		margin: ${({ theme }) => theme.spacings.large} 0;
		padding: ${({ theme }) => theme.spacings.small};
	`;

	export const Text = styled.span`
		display: block;
		text-align: center;
		${({ theme }) => theme.fonts.text.text1}
	`;

	export const Link = styled.a`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
		${({ theme }) => theme.fonts.text.text3};
		text-decoration: underline;
	`;
}
